import { api } from '@/lib/api';
import type {
  AvailabilityResponse,
  AvailabilityRule,
  AvailabilityException,
  CreateRuleRequest,
  UpdateRuleRequest,
  CreateExceptionRequest,
  SchedulingConfig,
  UpdateConfigRequest,
  DayView,
} from './types';

export async function fetch_availability(): Promise<AvailabilityResponse> {
  const res = await api.get<AvailabilityResponse>('/vendor/availability');
  return res.data;
}

export async function fetch_day_view(service_id: string, date: string): Promise<DayView> {
  const res = await api.get<DayView>('/vendor/availability/day', { params: { service_id, date } });
  return res.data;
}

export async function create_rule(input: CreateRuleRequest): Promise<AvailabilityRule> {
  const res = await api.post<AvailabilityRule>('/vendor/availability', input);
  return res.data;
}

export async function update_rule(id: string, input: UpdateRuleRequest): Promise<AvailabilityRule> {
  const res = await api.patch<AvailabilityRule>(`/vendor/availability/${id}`, input);
  return res.data;
}

export async function delete_rule(id: string): Promise<void> {
  await api.delete(`/vendor/availability/${id}`);
}

export async function create_exception(input: CreateExceptionRequest): Promise<AvailabilityException> {
  const res = await api.post<AvailabilityException>('/vendor/availability/exceptions', input);
  return res.data;
}

export async function delete_exception(id: string): Promise<void> {
  await api.delete(`/vendor/availability/exceptions/${id}`);
}

export async function update_config(input: UpdateConfigRequest): Promise<SchedulingConfig> {
  const res = await api.patch<SchedulingConfig>('/vendor/availability/config', input);
  return res.data;
}
